import React from 'react';
import { BookOpen, CheckCircle2 } from 'lucide-react';
import { Card, CardContent } from '../ui/Card';
export function MechanismSection() {
  return <section className="py-20 bg-slate-50" data-id="element-67">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-68">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-69">
          <span className="text-primary font-semibold tracking-wider uppercase text-sm" data-id="element-70">
            La Revelación
          </span>
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl mt-2 mb-6 font-serif" data-id="element-71">
            El Protocolo de Doble Bloqueo
          </h2>
          <p className="text-xl text-gray-600" data-id="element-72">
            La sincronización exacta entre alineación mecánica externa y
            desprogramación inflamatoria interna.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-73">
          {/* Mechanism 1 — with before/after image */}
          <Card className="border-none shadow-lg overflow-hidden" data-id="element-74">
            <div className="relative overflow-hidden h-64 bg-gray-50" data-id="element-75">
              <img src="https://cdn.magicpatterns.com/uploads/t329d4BtSCH4D63jDX1HxC/1694187243-pic1_(1).webp" alt="Corrección de 25° del Hallux Valgus con el corrector nocturno" className="w-full h-full object-contain" data-id="element-76" />
              <div className="absolute bottom-3 left-4 bg-blue-900/70 text-white text-xs font-semibold px-3 py-1 rounded-full" data-id="element-77">
                Corrección progresiva hasta 25°
              </div>
            </div>
            <CardContent className="p-8" data-id="element-78">
              <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-79">
                1. Acción Mecánica
              </h3>
              <p className="text-gray-600 mb-6" data-id="element-80">
                Nuestra férula nocturna reposiciona el eje del dedo mientras los
                ligamentos están relajados durante el sueño.
              </p>
              <ul className="space-y-3" data-id="element-81">
                <li className="flex items-start" data-id="element-82">
                  <CheckCircle2 className="h-5 w-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-83" />
                  <span className="text-gray-700" data-id="element-84">
                    Alineación progresiva sin dolor
                  </span>
                </li>
                <li className="flex items-start" data-id="element-85">
                  <CheckCircle2 className="h-5 w-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-86" />
                  <span className="text-gray-700" data-id="element-87">
                    Materiales de grado médico
                  </span>
                </li>
                <li className="flex items-start" data-id="element-88">
                  <CheckCircle2 className="h-5 w-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-89" />
                  <span className="text-gray-700" data-id="element-90">
                    Diseño ergonómico ajustable
                  </span>
                </li>
              </ul>
            </CardContent>
          </Card>

          {/* Mechanism 2 */}
          <Card className="border-none shadow-lg overflow-hidden" data-id="element-91">
            <div className="bg-teal-600 p-6 flex items-center justify-center h-56" data-id="element-92">
              <BookOpen className="h-20 w-20 text-white opacity-80" data-id="element-93" />
            </div>
            <CardContent className="p-8" data-id="element-94">
              <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-95">
                2. Acción Biológica
              </h3>
              <p className="text-gray-600 mb-6" data-id="element-96">
                Nuestro Ebook "Pies Sin Presión" te enseña a eliminar los ácidos
                inflamatorios de tu dieta y activar los músculos atrofiados.
              </p>
              <ul className="space-y-3" data-id="element-97">
                <li className="flex items-start" data-id="element-98">
                  <CheckCircle2 className="h-5 w-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-99" />
                  <span className="text-gray-700" data-id="element-100">
                    Desinflamación desde adentro
                  </span>
                </li>
                <li className="flex items-start" data-id="element-101">
                  <CheckCircle2 className="h-5 w-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-102" />
                  <span className="text-gray-700" data-id="element-103">
                    Ejercicios de fortalecimiento
                  </span>
                </li>
                <li className="flex items-start" data-id="element-104">
                  <CheckCircle2 className="h-5 w-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-105" />
                  <span className="text-gray-700" data-id="element-106">
                    Guía nutricional anti-inflamatoria
                  </span>
                </li>
              </ul>
            </CardContent>
          </Card>
        </div>

        {/* How-to steps with images */}
        <div className="max-w-5xl mx-auto mt-16" data-id="element-107">
          <h3 className="text-2xl font-bold text-gray-900 text-center mb-10 font-serif" data-id="element-108">
            Fácil de colocar en 4 pasos
          </h3>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-109">
            <div className="bg-white rounded-2xl overflow-hidden shadow-md" data-id="element-110">
              <div className="bg-gray-50 h-52 flex items-center justify-center" data-id="element-111">
                <img src="https://cdn.magicpatterns.com/uploads/ji1DFHXerHB6VFRALpQpcY/1694187601-howto2_(1).webp" alt="Paso 1: Colocar la correa del corrector de juanetes" className="h-full w-full object-contain" data-id="element-112" />
              </div>
              <div className="p-4" data-id="element-113">
                <span className="inline-block bg-blue-100 text-blue-700 text-xs font-bold px-2 py-1 rounded-full mb-2" data-id="element-114">
                  PASO 1
                </span>
                <p className="text-gray-700 font-medium text-sm" data-id="element-115">
                  Colocá el corrector sobre el pie y ajustá la correa principal
                </p>
              </div>
            </div>
            <div className="bg-white rounded-2xl overflow-hidden shadow-md" data-id="element-116">
              <div className="bg-gray-50 h-52 flex items-center justify-center" data-id="element-117">
                <img src="https://cdn.magicpatterns.com/uploads/gSAuMszrCdUVXhrdZzXucg/1694435167-howto2v2_(1).webp" alt="Paso 2: Ajustar la correa de tobillo" className="h-full w-full object-contain" data-id="element-118" />
              </div>
              <div className="p-4" data-id="element-119">
                <span className="inline-block bg-blue-100 text-blue-700 text-xs font-bold px-2 py-1 rounded-full mb-2" data-id="element-120">
                  PASO 2
                </span>
                <p className="text-gray-700 font-medium text-sm" data-id="element-121">
                  Asegurá la correa del tobillo para mayor estabilidad
                </p>
              </div>
            </div>
            <div className="bg-white rounded-2xl overflow-hidden shadow-md" data-id="element-122">
              <div className="bg-gray-50 h-52 flex items-center justify-center" data-id="element-123">
                <img src="https://cdn.magicpatterns.com/uploads/n23xoMv9VhUvnWLbwXawno/1715617753-BF4_(1).webp" alt="Paso 3: Ajustar la rueda de tensión del corrector" className="h-full w-full object-contain" data-id="element-124" />
              </div>
              <div className="p-4" data-id="element-125">
                <span className="inline-block bg-blue-100 text-blue-700 text-xs font-bold px-2 py-1 rounded-full mb-2" data-id="element-126">
                  PASO 3
                </span>
                <p className="text-gray-700 font-medium text-sm" data-id="element-127">
                  Girá la rueda de tensión hasta sentir una presión suave y
                  cómoda
                </p>
              </div>
            </div>
            <div className="bg-white rounded-2xl overflow-hidden shadow-md" data-id="element-128">
              <div className="bg-gray-50 h-52 flex items-center justify-center" data-id="element-129">
                <img src="https://cdn.magicpatterns.com/uploads/oG827BLAehzTZGFhpwhKpu/1715618005-bfhowto3_(1).webp" alt="Paso 4: Caminar cómodamente con el corrector puesto" className="h-full w-full object-contain" data-id="element-130" />
              </div>
              <div className="p-4" data-id="element-131">
                <span className="inline-block bg-green-100 text-green-700 text-xs font-bold px-2 py-1 rounded-full mb-2" data-id="element-132">
                  PASO 4
                </span>
                <p className="text-gray-700 font-medium text-sm" data-id="element-133">
                  ¡Listo! Usalo de noche y dejá que trabaje mientras dormís
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}